import {createContext, useState} from 'react'
import { makeRequest } from '../axios'
export const AdminContext = createContext()

export const AdminContextProvider = ({children}) => {  
 
    const [settings, setSettings] = useState(null)
    const [pharmacies, setPharmacies] = useState(null)
    const [loading, setLoading] = useState(null)
    const getSettings = async () => {
        setLoading(true)
        const res = await makeRequest('/admin/settings').finally(() => {setLoading(false)})
        setSettings(res.data.settings)
        return res.data.settings

    }

    const saveSettings = async (test_time, test_count) => {
        setLoading(true)
        const res = await makeRequest.post('/admin/settings-save', {test_time, test_count }).finally(() => {setLoading(false)})
        return res
    }


    const getPharmacies = async() => {
        setLoading(true)
        const res = await makeRequest.get('/admin/pharmacies').finally(() => {setLoading(false)})
        setPharmacies(res.data)
    }

    const getPharmacy = async(phId) => {
        try
        {
            const res = await makeRequest.get('/admin/pharmacies/'+phId)
      
            return res
        }catch(err)
        {
            return(err.response)
        }
    }

    const addPharmacy = async (pharamcy, num) => {
        try {
            const res = await makeRequest.post('/admin/pharmacies/add', {phName: pharamcy, phNum: num})
            return res
        } catch(err)
        {
            return err.response
        }
        

    }


    const getTestPermit = async(search = null) => {
        try {
            if(!search) return await makeRequest.get('/admin/test_permit')
            else return await makeRequest.get('/admin/test_permit/?search='+search)
            
           
        }catch(err)
        { 
            console.log(err)
            return(err)
        }
    }

    const postTestPermit = async (user_id) => {
        try {
            const res = await makeRequest.post('/admin/test_permit', {user_id})
            return res
        }catch(err)
        {
            
            return(err)
        }
    }

    const getCategoriesResult = async()=> {
        try{
            const res = await makeRequest.get('/admin/results')
            return res
        } catch(err)
        {
            return(err)
        }
    }

    const getCategoryById = async(id, search = null) => {
        try{
            if(!search)
            {
                return await makeRequest.get('/admin/results/'+id)
            } else {
                return await makeRequest.get('/admin/results/'+id + '?search='+search)
            }
          
        } catch(err)
        {
            return(err)
        }
    }

    const getRetakeResultsById = async(id) => {
        try{
            const res = await makeRequest.get('/admin/results-retake/'+id)
            return res
        } catch(err)
        {
            return(err)
        }
    }

    const getRetakeTestById = async(id) => {
        try{
            const res = await makeRequest.get('/admin/retake-test/'+id)
            return res
        } catch(err)
        {
            return(err)
        }
    }


    const postRetakeTest = async (user_id, category_id) =>
    {
        try{
            const res = await makeRequest.post('/admin/retake-test', {user_id, category_id})
            return res
        }
        catch(err)
        {
            return err
        }
    }

    const findUser = async (userData) => {
        try{
            const res = await makeRequest.get('/admin/users/find/'+userData)
            return res
        } catch(err)
        {
            return err
        }
    }

    const findMas= async (masData) => {
        try{
            const res = await makeRequest.get('/admin/mas/find/'+masData)
            return res
        } catch(err)
        {
            return err
        }
    }


    const getUser = async (user_id) => {
        try{
            const res = await makeRequest.get('/admin/users/'+user_id)
            return res
        } catch(err)
        {
            return err
        }
    }

    const enableUser = async (user_id) => {
        try{
            const res = await makeRequest.post('/admin/users/'+user_id+'/enable', {user_id})
            return res
        } catch(err)
        {
            return err
        }
    }
 
    const disableUser = async (user_id) => {
        try{
            const res = await makeRequest.post('/admin/users/'+user_id+'/disable', {user_id})
            return res
        } catch(err)
        {
            return err
        }
    }


    const getResult = async (user_id, category_id, test_id) => {
        try{
            const res = await makeRequest.get(`/admin/users/${user_id}/${category_id}/${test_id}`)
            return res
        } catch(err)
        {
            return err
        }
    }

    const getMas= async () => {
        try{
            const res = await makeRequest.get(`/admin/mas`)
            return res
        } catch(err)
        {
            return err
        }
    }

    const getMasByUserId= async (user_id) => {
        try{
            const res = await makeRequest.get(`/admin/mas/${user_id}`)
            return res
        } catch(err)
        {
            return err
        }
    }


    const enableMas = async (masId) => {
        try{

            const res = await makeRequest.post('/admin/mas/enable', {masId})
            return res
        } catch(err)
        {
            return err
        }
    }
 
    const disableMas = async (masId) => {
        try{
         
            const res = await makeRequest.post('/admin/mas/disable', {masId})
            return res
        } catch(err)
        {
            return err
        }
    }

    const masAddPh = async (masId) => {
        try{
            const res = await makeRequest.get('/admin/mas/'+masId+'/ph/add')
            return res
        } catch(err)
        {
            return err
        }
    }

    const masAddPhPost = async (masId, phId) => {
        try{
         
            const res = await makeRequest.post('/admin/mas/ph/add', {masId, phId})
            return res
        } catch(err)
        {
            return err
        }
    }

    const masDeletePhPost = async (masId, phId) => {
        try{
         
            const res = await makeRequest.post('/admin/mas/ph/delete', {masId, phId})
            return res
        } catch(err)
        {
            return err
        }
    }


    const addNewMas = async () => {
        try{
            const res = await makeRequest.get('/admin/mas/add')
            return res
        } catch(err)
        {
            return err
        }
    }

    const addNewMasPost = async (data) => {
        try{
            
            const res = await makeRequest.post('/admin/mas/add', {...data})
            return res
        } catch(err)
        {
            return err
        }
    }

    const addTest = async () => {
        try{
            const res = await makeRequest.get('/admin/add-test')
            return res
        } catch(err)
        {
            return err
        }
    }

    const addTestPost = async (answers, question) => {
        try{
            const res = await makeRequest.post('/admin/add-test', {answers, question})
            return res
        } catch(err)
        {
            return err
        }
    }

    const getCheckTests =  async () => {
        try{
            const res = await makeRequest.get('/admin/check_tests')
            return res
        } catch(err)
        {
            return err
        }
    }

    const editTest =  async (id) => {
        try{
            const res = await makeRequest.get('/admin/edit_test/'+id)
            return res
        } catch(err)
        {
            return err
        }
    }

    const editTestPost =  async (test_id, answers, question) => {
        try{
            const res = await makeRequest.post('/admin/edit_test/', {test_id, answers, question})
            return res
        } catch(err)
        {
            return err
        }
    }

    const addCategory =  async (date, category) => {
        try{
            
            const res = await makeRequest.post('/admin/add-category', {date, category})
            return res
        } catch(err)
        {
            return err
        }
    }


    
    const getCategoriesForMasRegionPharmacyReport =  async () => {
        try{
            const res = await makeRequest.get('/admin/reports/mas-region-pharmacy')
            return res
        } catch(err)
        {
            return err
        }
    }
   
    const getReportsMasRegionPharmacyCategoryId = async (id) => {
        try{
            const res = await makeRequest.get('/admin/reports/mas-region-pharmacy/'+id)
            return res
        } catch(err)
        {
            return err
        }
    }


    const getUserEditData = async (user_id) => {
        try{
            const res = await makeRequest.get(`/admin/users/${user_id}/edit`)
            return res
        } catch(err)
        {
            return err
        }
    }

    

    const postUserEditData = async (user_id, name, surname, num_ap) => {
        try{
            const res = await makeRequest.post(`/admin/users/${user_id}/edit`, {name, surname, num_ap})
            return res
        } catch(err)
        {
            return err
        }
    }

   
    
    

     

    


    return (
        <AdminContext.Provider value={{getSettings, getUserEditData, settings, getCheckTests, saveSettings, loading, getPharmacies, pharmacies, getPharmacy, addPharmacy, getTestPermit, postTestPermit, getCategoriesResult,getMasByUserId, getCategoryById, getRetakeResultsById, getRetakeTestById, postRetakeTest, findUser, getUser, enableUser, disableUser, getResult,getMas, disableMas, enableMas, masAddPh, masAddPhPost, masDeletePhPost, addNewMas, addNewMasPost, addTest, addTestPost, editTest, editTestPost, addCategory, getCategoriesForMasRegionPharmacyReport, getReportsMasRegionPharmacyCategoryId, postUserEditData, findMas}}>
          {children}
        </AdminContext.Provider>
    );
}